
const timelineDisplayOrder = {
  dayOff: 0,
  dayOffRequest: 1,
  tour: 2,
  assignment: 3
};


export default timelineDisplayOrder;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/utils/generate-timeline/timelineDisplayOrder.js